import { createSlice } from '@reduxjs/toolkit'

const initialState = {
   footerShow: true,
   showSidenav: true,

   /**
    * ผู้ใช้กด "ไว้ทีหลัง" บน dialog ตั้งค่าผู้ประกอบการไปแล้วหรือยัง (รอบการใช้งานนี้)
    *
    * อยู่ใน layout ซึ่ง **ไม่ได้ persist** (whitelist มีแต่ auth) — ปิดแท็บแล้วเปิดระบบใหม่
    * จึงขึ้นให้กรอกอีกครั้งเสมอตามที่ตั้งใจ ระหว่างนี้ยังเข้าถึงได้จากปุ่มมุมซ้ายบน
    */
   factorySetupSnoozed: false,
}

const layoutSlice = createSlice({
  name: 'layout',
  initialState,
  reducers: {
    setFooterShow: (state, action) => {
      state.footerShow = action.payload
    },
    setShowSidenav: (state, action) => {
      state.showSidenav = action.payload
    },
    snoozeFactorySetup: (state) => {
      state.factorySetupSnoozed = true
    },
    openFactorySetup: (state) => {
      state.factorySetupSnoozed = false
    },
  },
})

export const { setFooterShow, setShowSidenav, snoozeFactorySetup, openFactorySetup } =
  layoutSlice.actions
export default layoutSlice.reducer
